export const virtualizationConfig = {
  itemsLimit: 1000
};
